import { render, staticRenderFns } from "./Anexo24.vue?vue&type=template&id=00c55c8c&scoped=true&"
import script from "./Anexo24.vue?vue&type=script&lang=js&"
export * from "./Anexo24.vue?vue&type=script&lang=js&"
import style0 from "./Anexo24.vue?vue&type=style&index=0&id=00c55c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c55c8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
